import app from './app';

export default function displayError(error: Error) {
	app('errorHandler').display(error);
}
